import React from 'react';

// SVG Shield Logo Component - Bold & Strong Style
const ShieldLogo = ({ width = 40, height = 40 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 100 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shield Outline - Bolder Navy Blue */}
      <path 
        d="M50 8 L85 22 L85 58 Q85 88 50 110 Q15 88 15 58 L15 22 Z" 
        fill="white" 
        stroke="#1e40af" 
        strokeWidth="5"
      />
      
      {/* Magnifying Glass Circle - Bolder */}
      <circle cx="48" cy="58" r="22" fill="white" stroke="#1e40af" strokeWidth="4.5"/>
      
      {/* Magnifying Glass Handle - Much Bolder */}
      <line x1="64" y1="74" x2="76" y2="86" stroke="#1e40af" strokeWidth="6.5" strokeLinecap="round"/>
      
      {/* Gradient definitions - More vibrant */}
      <defs>
        <linearGradient id="barGradient" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#047857" />
          <stop offset="50%" stopColor="#059669" />
          <stop offset="100%" stopColor="#10b981" />
        </linearGradient>
      </defs>
      
      {/* Bar Chart - Wider and more prominent bars */}
      {/* Bar 1 (shortest) */}
      <rect x="35" y="65" width="6" height="9" fill="url(#barGradient)" rx="1.5"/>
      
      {/* Bar 2 (medium) */}
      <rect x="43" y="60" width="6" height="14" fill="url(#barGradient)" rx="1.5"/>
      
      {/* Bar 3 (tallest) */}
      <rect x="51" y="52" width="6" height="22" fill="url(#barGradient)" rx="1.5"/>
      
      {/* Upward Trend Line - Bolder and more prominent */}
      <polyline 
        points="33,69 38,66 43,62 48,57 53,51 58,45 62,40" 
        stroke="#0891b2" 
        strokeWidth="3.5" 
        fill="none" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      
      {/* Upward Arrow - Much bolder */}
      <g transform="translate(72, 18)">
        <path 
          d="M0 14 L0 0 M0 0 L-5 5 M0 0 L5 5" 
          stroke="#1e40af" 
          strokeWidth="4.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </svg>
  );
};

const FundWiseLogo = ({ size = 'md', variant = 'default' }) => {
  const sizes = {
    sm: { logo: 32, text: 'text-lg' },
    md: { logo: 40, text: 'text-2xl' },
    lg: { logo: 48, text: 'text-3xl' },
    xl: { logo: 64, text: 'text-4xl' }
  };

  const variants = {
    default: {
      brandText: 'bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent'
    },
    dark: {
      brandText: 'bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent'
    },
    light: {
      brandText: 'bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent'
    }
  };

  const currentSize = sizes[size];
  const currentVariant = variants[variant];

  return (
    <div className="flex items-center space-x-3">
      {/* Professional Shield Logo SVG - Bold Style */}
      <ShieldLogo width={currentSize.logo} height={currentSize.logo * 1.2} />
      
      {/* Logo Text with Gradient */}
      <div className="flex flex-col">
        <span className={`${currentSize.text} font-bold ${currentVariant.brandText}`} style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Portfolio Auditor
        </span>
        {size === 'xl' && (
          <span className="text-sm text-slate-600 font-medium -mt-1">
            Portfolio Analyzer
          </span>
        )}
      </div>
    </div>
  );
};

// Alternative Minimal Logo
export const FundWiseLogoMinimal = ({ size = 'md' }) => {
  const sizeClasses = {
    sm: { container: 'w-8 h-8', text: 'text-xs' },
    md: { container: 'w-10 h-10', text: 'text-sm' },
    lg: { container: 'w-12 h-12', text: 'text-base' },
    xl: { container: 'w-16 h-16', text: 'text-xl' }
  };

  const currentSize = sizeClasses[size];

  return (
    <div className={`${currentSize.container} bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center border-2 border-blue-600 shadow-md`}>
      <span className={`${currentSize.text} font-bold text-white tracking-tight`} style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        PA
      </span>
    </div>
  );
};

// Icon-only version for favicons
export const FundWiseIcon = ({ className = "w-8 h-8" }) => {
  return (
    <div className={`${className} bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center border-2 border-blue-600 shadow-md`}>
      <span className="text-xs font-bold text-white tracking-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        PA
      </span>
    </div>
  );
};

export default FundWiseLogo;